import slice from './workspacesSlice';

export * from './types';

export const {
  populateWorkspaces,
  clearWorkspaces,
  updateWorkspaces,
  setWorkspaceLastVisitedPathname,
} = slice.actions;
export default slice.reducer;
